import React from 'react';

export function Field({
  label,
  as = 'input',
  type = 'text',
  required = false,
  hint = '',
  options = [],
  placeholder = '',
  style = {},
  ...rest
}) {
  const control = {
    width: '100%',
    boxSizing: 'border-box',
    padding: as === 'textarea' ? '12px 15px' : '13px 15px',
    fontFamily: 'var(--font-ui)',
    fontSize: '16px',
    color: 'var(--text-strong)',
    background: 'var(--white)',
    border: '2px solid var(--tan-200)',
    borderRadius: 'var(--radius-sm)',
    outline: 'none',
    transition: 'border-color var(--dur) var(--ease)',
    minHeight: as === 'textarea' ? '120px' : 'auto',
    resize: as === 'textarea' ? 'vertical' : undefined,
    appearance: as === 'select' ? 'none' : undefined,
  };

  const onFocus = (e) => { e.currentTarget.style.borderColor = 'var(--navy-800)'; };
  const onBlur = (e) => { e.currentTarget.style.borderColor = 'var(--tan-200)'; };

  return (
    <label style={{ display: 'block', ...style }}>
      {label && (
        <span style={{ display: 'block', marginBottom: '8px', fontFamily: 'var(--font-ui)', fontSize: '14px', fontWeight: 600, color: 'var(--text-strong)' }}>
          {label}{required && <span style={{ color: 'var(--burgundy-700)' }}> *</span>}
        </span>
      )}
      {as === 'textarea' ? (
        <textarea style={control} required={required} placeholder={placeholder} onFocus={onFocus} onBlur={onBlur} {...rest} />
      ) : as === 'select' ? (
        <div style={{ position: 'relative' }}>
          <select style={control} required={required} onFocus={onFocus} onBlur={onBlur} {...rest}>
            {placeholder && <option value="">{placeholder}</option>}
            {options.map((o) => (
              <option key={o.value ?? o} value={o.value ?? o}>{o.label ?? o}</option>
            ))}
          </select>
          <span style={{ position: 'absolute', right: '14px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: 'var(--tan-600)' }}>▾</span>
        </div>
      ) : (
        <input style={control} type={type} required={required} placeholder={placeholder} onFocus={onFocus} onBlur={onBlur} {...rest} />
      )}
      {hint && <span style={{ display: 'block', marginTop: '6px', fontSize: '13px', color: 'var(--text-muted)' }}>{hint}</span>}
    </label>
  );
}
